export default function Footer() {
  return (
    <footer id="disclaimer" className="bg-background-900 text-background-100">
      {/* 追踪 CTA */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="rounded-xl bg-background-800 p-6 md:p-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 border border-background-700/60">
          <div>
            <p className="text-xs font-medium text-accent-400 mb-2 inline-flex items-center gap-1.5">
              <i className="ri-notification-3-line w-4 h-4 flex items-center justify-center" />
              追踪提醒 · 静态演示
            </p>
            <h2 className="text-lg md:text-2xl font-semibold font-heading text-background-50">
              想跟进「反差黑料人物是谁」的下一步？
            </h2>
            <p className="mt-2 text-sm text-background-300/90">
              时间线与疑点状态会随公开信息演进持续更新。本处为静态展示，不采集、不提交任何信息。
            </p>
          </div>
          <div className="w-full lg:w-auto flex flex-col sm:flex-row gap-3">
            <div className="flex items-center rounded-md bg-background-50 h-11 px-3">
              <i className="ri-mail-line text-foreground-400 mr-2 w-4 h-4 flex items-center justify-center" />
              <input
                type="text"
                aria-label="请输入邮箱（静态演示）"
                placeholder="邮箱 / 联系方式"
                className="h-full w-48 md:w-60 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button className="h-11 px-5 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer">
              开启追踪
            </button>
          </div>
        </div>
      </div>

      {/* 主体页脚 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 border-t border-background-700/60 pt-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-7 h-7 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-spy-line w-4 h-4 flex items-center justify-center" />
              </span>
              <span className="text-lg font-bold font-heading text-background-50">反差黑料</span>
            </div>
            <p className="mt-3 text-xs leading-6 text-background-300/80 max-w-md">
              围绕反差黑料人物身份与争议焦点做交叉梳理的资讯聚合页，帮你快速定位反差黑料是谁、事件核心人物有哪几位。页面内容随公开信息演进持续更新。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">栏目</h4>
            <ul className="space-y-2 text-xs text-background-300/80">
              {[
                ["人物追踪", "#personas"],
                ["扒皮时间线", "#timeline"],
                ["疑点核查", "#doubts"],
                ["话题热榜", "#topics"],
              ].map(([t, h]) => (
                <li key={h}>
                  <a href={h} className="hover:text-background-50 transition-colors">{t}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">关于</h4>
            <ul className="space-y-2 text-xs text-background-300/80">
              {[["更新记录", "#timeline"], ["网友FAQ", "#faq"], ["内容声明", "#disclaimer"]].map(([t, h]) => (
                <li key={h}>
                  <a href={h} className="hover:text-background-50 transition-colors">{t}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 免责声明 */}
        <div className="mt-8 rounded-lg border border-background-700/60 bg-background-800/60 p-4 md:p-5">
          <p className="text-xs font-medium text-accent-400 mb-2 inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center" />
            内容声明 · 免责说明
          </p>
          <p className="text-xs leading-6 text-background-300/80">
            本站为针对「反差黑料」话题的资讯聚合与信息梳理页，所有表述均基于公开渠道的讨论与引用进行归置，不对任何真实个人或组织作出实名定性，也不构成侵权指控。文中人物代号仅指代讨论中被反复提到的内容身份。凡未获得独立核验的信息，均已在正文标注「待证 / 存疑 / 矛盾」状态。如相关权利方认为本页内容不当，可联系我们核删；建议读者以可核验的原始材料为准，理性看待网络讨论。
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-background-700/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-background-400">© 2026 反差黑料 · 资讯聚合专题 · 仅作信息整理，不代表本站立场</p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#personas" className="hover:text-background-200 transition-colors">回到顶部</a>
            <a href="#faq" className="hover:text-background-200 transition-colors">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}